import styled from "styled-components";

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  visibility: hidden;
`;

export const ItemWrapper = styled.div`
  width: ${({ itemLevel }) =>
    `calc(100% - ${itemLevel > 0 && itemLevel * 12}px)`};
  margin-left: ${({ itemLevel }) => `${itemLevel > 0 && itemLevel * 12}px`};
`;

export const ItemContainer = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  padding: 8px 0px 8px 0px;
  box-sizing: border-box;
  width: 100%;
  column-gap: 16px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.background};
  background-color: ${({ isSelected, isHoveringOver, theme }) => {
    if (isHoveringOver || isSelected) return theme.orgchart.backgroundHover;
    return theme.background;
  }};
  border: ${({ isSelected, isHoveringOver, isChildOfSelectedUser }) => {
    if (isSelected || isHoveringOver || isChildOfSelectedUser) {
      return "1px solid #4c9aff";
    }
    return `1px solid ${({ theme }) => theme.borderColor};`;
  }};

  cursor: pointer;

  &:hover {
    background-color: ${({ isSelected, theme }) =>
      isSelected
        ? theme.orgchart.backgroundHover
        : theme.orgchart.backgroundHover};
    border-color: ${({ isSelected, isChildOfSelectedUser, theme }) =>
      isSelected || isChildOfSelectedUser ? "#4C9AFF" : theme.borderColor};

    ${UserActionsWrapper} {
      visibility: visible;
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.orgchart.backgroundHover};
    border-color: #4c9aff;
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  grid-template-columns: 24px auto;
  align-items: center;
  column-gap: 8px;
`;

export const IconContainer = styled.div`
  display: grid;
  place-content: center;
  height: 24px;
  width: 24px;
`;

export const ClickableIcon = styled(IconContainer)`
  cursor: pointer;

  svg,
  rect,
  path {
    color: #97a0af !important;
    fill: #97a0af !important;
  }

  &:hover {
    svg,
    rect,
    path {
      color: #42526e !important;
      fill: #42526e !important;
    }
  }
`;

export const RotateableIconContainer = styled(IconContainer)`
  transition: transform 0.2s ease;
  ${({ shouldRotate }) => shouldRotate && `transform: rotate(90deg);`};
  cursor: pointer;
`;
